/**
 * 圆环统计
 * Created by yangxinxin on 2016/12/14.
 */
'use strict';
/**
 * 简单饼状统计
 * @module PieStatisticsLayer
 */
define([
    './StatisticsLayer',
    '../utils/CommonUtil',
    '../g2'
],function(
    StatisticsLayer,
    CommonUtil,
    g2
){
    /**
     * 构造方法
     * @constructor
     * @classdesc 简单饼状统计图层
     * @augments G.lys.StatsticsLayer
     * @alias G.lys.PieStatisticsLayer
     * @param {Object} options - 必填，构造参数；
     * @param {G.Map/g2.carto.Map} options.map -必填，地图对象
     * @param {Object} options.symbolConfig - 可选，符号配置对象；
     * @param {String} options.layerId 可选，- 图层id，默认为随机字符串
     * @param {Number} options.spatialReference - 可选，图层坐标系，默认地图坐标系
     * @param {Number} options.dataSpatialReference - 可选，叠加数据的坐标系，默认地图坐标系
     * @param {String} options.geometryField - 可选，空间属性名，默认为空，如果有值，则几何使用数据记录中对应的坐标信息；
     * @param {String} options.xField - 可选，数据记录中x坐标字段名，默认为LONGITUDE
     * @param {String} options.yField - 可选，数据记录中y坐标字段名，默认为LATITUDE
     * @param {Function} options.symbolUpdateCallback - 可选，地图显示的符号更新时的回调，
     * @param {Object} options.callbackContext - 可选，回调的上下文
     * @returns {Class} - 实例化的对象
     */
    var layer=StatisticsLayer.extend({
        options: {
            //wkt或者geojson字段名称，指定这个字段则读取数据中的这个属性作为坐标；不指定则默认为点，根据x、y获取坐标；
            geometryField:''
        },
        initialize: function (options) {
            StatisticsLayer.prototype.initialize.call(this,options);
            //创建要素图层
            this.layer=new g2.carto.ElementLayer({
                id:this.options.layerId,
                name:this.options.layerName,
                map: this.map
            });
            //
            this._addListeners();
        },
        /***
         * 添加监听
         * @private
         */
        _addListeners:function(){
            StatisticsLayer.prototype._addListeners.call(this);
            //
            this.map.listen('click',this._getMapClickListener());
        },
        /***
         * 移除监听
         * @private
         */
        _removeListeners:function(){
            this.map.off('click',this._getMapClickListener());
            //
            StatisticsLayer.prototype._removeListeners.call(this);
        },
        /***
         * 鼠标滑过事件
         * @returns {layer._mapMouseMoveListener|*}
         * @private
         */
        _getMapClickListener:function(){
            if(!this._mapClickListener){
                var self=this;
                this._mapClickListener=function(event){
                    var ele=self.layer.hitTest(event.screenX, event.screenY);
                    if(ele){
                        self.fire('click',{
                            id:ele.element.id,
                            element:ele.element,
                            layer:ele.layer
                        });
                    }
                };
            }
            return this._mapClickListener;
        },
        /**
         * 更新统计的数据
         * @method
         * @memberOf G.lys.PieStatisticsLayer.prototype
         * @params {Object} options - 必填，更新的参数
         * @params {Object} options.statisticsData - 必填，统计的数据
         * @params {Object/String} options.symbol - 必填，如果传递对象，则传递符号样式；
         * 如果传递字符串，则为初始化时配置的符号集里的key值；
         * options.key {String} 可选，统计的资源标识
         * options.title {String} 可选， 统计的资源名称
         */
        updateStatistics:function(options){
            if(!options){
                return ;
            }
            this._updateStatistics(options);
        },
        /**
         * 更新统计的数据
         * @params options {Object} 必填，更新的参数
         * @private
         * @param options.statisticsData {Object} 必填，统计的数据
         * @param options.symbol {Object/String}　必填，如果传递对象，则传递符号样式；
         * @param options.key {String} 可选，统计的资源标识;如果传递字符串，则为初始化时配置的符号集里的key值；
         * @param options.title {String} 可选， 统计的资源名称
         */
        _updateStatistics:function(options){
            if(!options){
                return ;
            }
            var statisticsData=jQuery.extend(true,{},options.statisticsData),
                symbol=options.symbol;
            if(typeof symbol=='string'){
                symbol=this.symbolConfig[symbol];
            }
            symbol=jQuery.extend(true,{},symbol);
            this.statisticsData=statisticsData;
            this.layer.clear(true);
            this._updateLayer(symbol);
            //notify symbol updated
            this._onSymbolsUpdated(options);
            //notify elements changed
            this._onElementChanged();
        },
        /**
         * 显示隐藏
         * @method
         * @memberOf G.lys.PieStatisticsLayer.prototype
         * @param {Boolean} visible
         */
        setVisible:function(visible){
            this.layer.setVisible(!!visible);
            //
            this._visible=!!visible;
            //更新图例
            if(visible){
                this.invokeCallback('symbolUpdateCallback',{
                    layerId:this.options.layerId,
                    symbols:this.currentSymbols
                });
            }else{
                this.invokeCallback('symbolUpdateCallback',{
                    layerId:this.options.layerId,
                    symbols:[]
                });
            }
        },
        /**
         * 清空
         * @method
         * @memberOf G.lys.PieStatisticsLayer.prototype
         */
        clear:function(noNotify){
            this.layer.clear();
            this.statisticsData=null;
            //
            StatisticsLayer.prototype.clear.call(this);
            if(!noNotify){
                //notify symbol updated
                this._onSymbolsUpdated();
                //notify elements changed
                this._onElementChanged();
            }
        },
        _updateLayer:function(config){
            var key,markerSym=config.symbol,textSym=config.label;
            for(key in this.statisticsData){
                var data=this.statisticsData[key];
                var geom=this._getGeometry(data,this.options),
                    symbol=this.getRingTextSymbol(data.value,markerSym,textSym);
                var polygonEle = new g2.sfs.Element({
                    id:key,
                    geometry: geom,
                    symbol: symbol
                });
                polygonEle._data=data;
                this.layer.add(polygonEle);
                // //测试标注的位置
                // var testSym = new g2.sfs.SimpleMarkerSymbol({
                //         fillColor: new g2.sfs.Color({a: 255, r: 24 + i * 20, g: 25 + i * 20, b: 255 - i * 20}),
                //         size: 3 + 0.3 * i
                //     }
                // );
                // var testEl = new g2.sfs.Element({geometry: geom, symbol: testSym});
                // this.layer.add(testEl);
            }
        },
        /**
         * 符号改变时调用的方法
         * @private
         */
        _onSymbolsUpdated:function(options){
            this.currentSymbols=null;
            if(options&&this.layer.elements.length>0){
                var element=this.layer.elements[0];
                this.currentSymbols=[{
                    title:options.title,
                    symbol:element.symbol,
                    symbolKey:options.key
                }];
            }else{
                this.currentSymbols=[];
            }
            //invoke callback
            this.invokeCallback('symbolUpdateCallback',{
                layerId:this.options.layerId,
                symbols:this.currentSymbols
            });
        },
        /**
         * 获取图层
         * @method
         * @memberOf G.lys.PieStatisticsLayer.prototype
         * @returns {Object}
         */
        getLayer:function(){
            return this.layer;
        },
        /**
         * @method
         * @returns {Array}
         */
        getElements:function(){
            return this.layer.elements;
        },
        /**
         * 获取几何对象
         * @param data
         * @param options
         * options.spatialReference 叠加的坐标系
         * options.dataSpatialReference 数据源坐标系
         * @returns {*}
         * @private
         */
        _getGeometry:function(data,options){
            var geometry=null;
            if(this.options.geometryField){//wkt或者geojson
                var coordinates=data[this.options.geometryField];
                if(coordinates){
                    if(coordinates instanceof String){
                        geometry = g2.sfs.GeometryFactory.createGeometryFromWkt(coordinates);
                        geometry.setSpatialReference(options.spatialReference);
                    }else{
                        geometry = g2.sfs.GeometryFactory.createGeometryFromGeoJson(coordinates);
                        geometry.setSpatialReference(options.spatialReference);
                    }
                }
            }else{//根据经纬度
                geometry=new g2.sfs.Point({x:data[options.xField],y: data[options.yField],
                    spatialReference: options.spatialReference});
            }
            //需要转换坐标系
            if(options.spatialReference&&
                options.destSpatialReference&&
                options.spatialReference!=options.destSpatialReference){
                geometry=this.projService.transform(geometry,options.destSpatialReference);
            }
            return  geometry;
        },
        /**
         * 根据统计的总数，样式生成圆环文字复合符号；
         * @method
         * @param text
         * @param markerSym
         * @param textSym
         * @private
         */
        getRingTextSymbol:function(text,markerSym,textSym){
            text=text+'';
            markerSym=markerSym||{};
            textSym=textSym||{};
            //
            if(markerSym.borderColor){
                markerSym.borderColor=this._getColor(markerSym.borderColor);
            }
            if(markerSym.fillColor){
                markerSym.fillColor=this._getColor(markerSym.fillColor);
            }
            if(textSym.foreground){
                textSym.foreground=this._getColor(textSym.foreground);
            }
            if(textSym.borderColor){
                textSym.borderColor=this._getColor(textSym.borderColor);
            }
            //
            var fontSize=textSym.fontSize||15,
                minSize=fontSize*2/3,
                offsetX = 0, offsetY = 0;
            var size=CommonUtil.getEquivalentNum(text,minSize,minSize);
            var markerDefaultSym={
                borderColor: new g2.sfs.Color({a: 150, r: 50, g: 175, b: 254}),
                fillColor: new g2.sfs.Color({a: 220, r: 4, g: 131, b: 232}),
                borderThickness: size/2,
                size:size
            },textDefaultSym={
                text:text,
                fontSize:fontSize,
                fontWeight:1,
                offsetX:offsetX,   //横向偏移正值向右 负值向左
                offsetY:offsetY,  //纵向偏移正值向下 负值向上
                foreground: new g2.sfs.Color({a: 255, r: 255, g: 255, b: 255}),
                borderColor:new g2.sfs.Color({a: 1, r: 255, g: 255, b: 255}),
                borderThickness:0
            };
            jQuery.extend(true,markerDefaultSym,markerSym);
            jQuery.extend(true,textDefaultSym,textSym);
            //点符号
            var markerSymbol = new g2.sfs.SimpleMarkerSymbol(markerDefaultSym);

            //文本符号  如果没有offsetX和offsetY文字在中间显示
            var textSymbol=new g2.sfs.TextSymbol(textDefaultSym);
            //复合符号
            var currencySymbol = new g2.sfs.CurrencySymbol({
                markerSymbol:markerSymbol,
                textSymbol:textSymbol
            });
            return currencySymbol;
        },
        /**
         * 销毁方法
         * @method
         * @memberOf G.lys.PieStatisticsLayer.prototype
         */
        destroy:function(){
            //
            StatisticsLayer.prototype.destroy.call(this);
        }

    });
    /**
     * 定义图层类型
     */
    Object.defineProperty(layer,'type',{
        value:41,
        configurable:false,
        writable:false
    });
    return layer;
});
